import { Box, Stack } from '@mui/material';
import { MgItemCard } from '@retail/products/types';
import { Paper } from '@shared/components';
import { useMemo, useState } from 'react';
import { JsonViewer } from '@textea/json-viewer';
import { useFetchRawMgItem } from '@retail/products/data-access';
import { Comparison } from '@retail/products/components';
import { useProductsTFunction } from '@retail/products/i18n';
import { MgItemRaw, MgSupplierItemRaw } from '@retail/products/types';

interface Props {
  selectedMgSupplierId?: number;
  mgItem: MgItemCard;
}

export const JSONContainer = ({ mgItem, selectedMgSupplierId }: Props) => {
  const t = useProductsTFunction();

  const { data: jsonDTO } = useFetchRawMgItem({
    mgItemNumber: mgItem.mgItemNumber,
  });
  const mgItemJSON = jsonDTO && MgItemRaw.fromDto(jsonDTO);

  const selectedSupplierItem = useMemo(
    () =>
      mgItemJSON?.mgSupplierItems?.find(
        (supplierItem) => supplierItem.mgSupplierId === selectedMgSupplierId
      ),
    [mgItemJSON?.mgSupplierItems, selectedMgSupplierId]
  );
  const [comparisonSupplier, setComparisonSupplier] = useState<MgSupplierItemRaw | null>(null);

  const unselectedSupplierItems =
    mgItemJSON?.mgSupplierItems?.filter(
      (supplierItem: MgSupplierItemRaw) => supplierItem.mgSupplierId !== selectedMgSupplierId
    ) ?? [];

  const getMgItemSupplier = (
    supplierId: MgSupplierItemRaw['mgSupplierId'],
    mgSupplierItemId: MgSupplierItemRaw['mgSupplierItemId']
  ) =>
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    mgItem.mgSupplierItems.find(
      (s) => s.mgSupplier.mgSupplierId === supplierId && s.mgSupplierItemId === mgSupplierItemId
    )!;

  if (!selectedSupplierItem) {
    return <Paper paddingY="dense">{t('products.mgItem.json.noSuppliersInfo')}</Paper>;
  }

  return (
    <Stack>
      <Comparison
        getMgItemSupplier={getMgItemSupplier}
        comparisonSupplier={comparisonSupplier}
        setComparisonSupplier={setComparisonSupplier}
        selectedSupplierItem={selectedSupplierItem}
        supplierItems={unselectedSupplierItems}
      />

      <Box
        display="flex"
        flexGrow={1}
        overflow="hidden"
        sx={{
          border: '1px solid',
          borderColor: 'grey.50',
          padding: 2,
        }}
      >
        <JsonViewer value={selectedSupplierItem} style={{ fontSize: 12, display: 'flex' }} />
      </Box>
    </Stack>
  );
};
